import { MarketingEntryPoint } from "@redotech/redo-marketing-entry-point-common/marketing-entry-point";
import { createEnum } from "@redotech/zod-util/zod-enum";
import * as z from "zod";

export const subscribeToEmailMarketingSchema = {
  name: "subscribeToEmailMarketing" as const,
  input: z.object({
    email: z.string(),
    entryPoint: createEnum(MarketingEntryPoint),
    agreementText: z.string(),
  }),
  output: z.object({ success: z.boolean() }),
};
